export default __webpack_public_path__ + "static/media/logo-text.225745ba.svg";